import React from "react";

const OrderContext = React.createContext(null);

export default OrderContext;